export default __webpack_public_path__ + "static/media/support.00ffd9d1.svg";